module.exports = __webpack_public_path__ + "static/img/OM11.fec2b356.png";